import {User} from "../pay/User";
import {PAYMENT_TYPE_PAYPAL} from "../../const/Pay";
import {getEventDeviceType, objToFormData} from "../../utils/common";
import {DEFAULT_LANGUAGE, getLanguageServerCode} from "../../const/Language";
import {getCurrentApiEnvConfig, getCurrentWebsiteBaseUrl} from "../../config/config";

export class ApiService{
    constructor() {
        const apiEnvConfig = getCurrentApiEnvConfig();
        this.apiHost = apiEnvConfig.appServiceBaseUrl;
        this.host = getCurrentWebsiteBaseUrl();

        this.language = "en";
        this.user = new User();
    }

    getHeaders(){
        const user = new User();
        return user.getUserHeaders();
    }
    getCreateCustomerUserApiUrl(){
        return `${this.apiHost}/api/v3/user/initialise`;
    }
    getCreateCustomerRequestData(){
        let login_info = {
            login_type: 1,
        };
        let device_info = this.user.getDeviceInfo();
        let data = {
            login_info: JSON.stringify(login_info),
            device_info: JSON.stringify(device_info),
            language_code: "0",
            country_code: this.user.getCountryCode(),
        };
        return objToFormData(data);
    }
    getH5ResultApiUrl(){
        return `${this.apiHost}/api/v3/userprofile/get_h5_result`;
    }
    getH5ResultData(){
    }
    sendEmailForWebsiteUrl(){
        return `${this.apiHost}/api/v3/userprofile/send_email_for_website`;
    }
    sendEmailForWebsiteRequestData(questionnaireName, userId, formData){
        const workoutName = questionnaireName || formData?.getWorkoutName?.() || "";
        const data = {
            email: formData.email?.trim()?.toLowerCase(),
            user_name: formData.userName,
            user_id: userId,
            result_data: JSON.stringify({
                questionnaire_responses: formData.toPlainObject(),
                submission_details : {
                    workout_name: workoutName,
                    user_survey_id: this.user.getDeviceToken(),
                    device_type: getEventDeviceType(), // ios android web
                    currency: this.user.getCurrencyCode(),
                    main_goal_lokalise: formData.getMainGoalLokalise()
                }
            }),
        };
        return objToFormData(data);
    }
    saveUserProfileUrl(){
        return `${this.apiHost}/api/v3/userprofile/save_user_profile_for_website`;
    }
    saveUserProfileData(userId, formData){
        const data = {
            country_code: this.user.getCountryCode(),
            language_code: getLanguageServerCode(this.language),
            user_profile: formData.toUserProfile(userId)
        };
        return objToFormData(data);
    }
    getSubscriptionRequestDataUrl(){
        return `${this.apiHost}/api/v3/purchase/create_payment_session`;
    }

    getSubscriptionRequestDataRequestData(sku, email, discount_amount, dynamicCycleSubscription, paymentType = PAYMENT_TYPE_PAYPAL){
        let prefixLanguage = "";
        if (this.language !== DEFAULT_LANGUAGE) {
            prefixLanguage = `${this.language}/`;
        }
        let data = {
            user_id: this.user.getUserId(),
            device_type: 4,
            payment_type: paymentType, //5: stripe, 6: paypal
            stripe_elements: 1,
            sku: sku,
            email: email?.trim()?.toLowerCase(),
            discount_amount: discount_amount,
            success_url: `${this.host}/${prefixLanguage}pay/verify`,
            cancel_url: `${window.location.href}`,
            currency: this.user.getCurrencyCode(),
        };
        if (dynamicCycleSubscription) {
            data.dynamic_cycle_subscription = 0;
        }
        if (discount_amount < 0 || !discount_amount) {
            data.discount_amount = 0;
        }

        if (paymentType == PAYMENT_TYPE_PAYPAL) {
            delete data.stripe_elements;
            delete data.discount_amount;
        }

        return objToFormData(data);
    }
    verifyRequestUrl(){
        return `${this.apiHost}/api/v3/purchase/verify`;
    }
    verifyRequestData(sku, sessionId, paymentType = PAYMENT_TYPE_PAYPAL){
        const userId = this.user.getUserId();
        const deviceType = 4;
        if (!userId || !sessionId || !deviceType) {
            return undefined;
        }
        const data = {
            sku: sku, //window.PAY_SKU,
            user_id: userId,
            quantity: 1,
            device_type: deviceType,
            payment_type: paymentType, //5: stripe, 6: paypal
            receipt_data: sessionId,
        };
        return objToFormData(data);
    }
    uploadUserInfoRequestUrl(){
        return `${this.apiHost}/api/v3/userprofile/send_email_for_website_v2`;
    }
    uploadUserInfoRequestData(email, userName){
        const userId = this.user.getUserId();
        const data = {
            email: email?.trim()?.toLowerCase(),
            user_name: userName,
            user_id: userId,
        };
        return objToFormData(data);
    }
    loginOrCreateForWebsiteUrl(){
        return `${this.apiHost}/api/v3/user/login_or_create_for_website`;
    }
    loginOrCreateForWebsiteData(email, password){
        const data = {
            login_info: JSON.stringify({
                login_type: 3,
                login_key: email?.trim()?.toLowerCase(),
                login_password: password,
            }),
            device_info: JSON.stringify(this.user.getDeviceInfo()),
            login_action: 2,
        };
        return objToFormData(data);
    }
}
